/* eslint-disable react/prop-types */
/* eslint-disable no-param-reassign */
import React, { Component } from 'react';
import { Route, Routes, useLocation, useParams, useNavigate } from 'react-router-dom';

import { scrollToTop } from '../components/common/Helpers/index';

/**
 * Returns a composite component where a {@link Route} component wraps the provided component
 *
 * @param {React.Component} WrappedComponent    - React component to be wrapped
 * @param {string} [extension=html]             - extension used to identify a route amongst the tree of resource URLs
 * @returns {CompositeRoute}
 */

export const withRouterV6 = (WrappedComponent, extension) => (props) => {
  const location = useLocation();
  const params = useParams();
  const push = useNavigate();

  const routePath = props.cqPath;
  if (!routePath) {
    return <WrappedComponent {...props} location={location} match={{ params }} history={{ push }} />;
  }
  extension = extension || 'html';

  const newRoute = (
    <Routes>
      <Route
        key={routePath}
        path={`${routePath}.${extension}`}
        element={<WrappedComponent {...props} location={location} match={{ params }} history={{ push, location }} />}
      />
    </Routes>
  );

  return newRoute;
};

/**
 * ScrollToTop component will scroll the window on every navigation.
 * wrapped in in `withRouter` to have access to router's props.
 */
class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      scrollToTop();
    }
  }

  render() {
    return this.props.children;
  }
}
export default ScrollToTop;
